import React from "react";
import {PricingTierItem} from "src/utils/fetchPricingData";

import PricingItem from "./PricingItem";

interface SectionGroupProps {
  title: string;
  items: PricingTierItem[];
}

const SectionGroup: React.FC<SectionGroupProps> = ({title, items}) => {
  if (items.length === 0) return null;

  return (
    <div data-testid={`section-group-${title}`} className="pb12 pb8-sm">
      <h3 className="gray600 fs14 ls12 ttu font-im pb6 pb3-sm">{title}</h3>
      <ul className="dg gg2 gafr">
        {items.map(item => (
          <PricingItem key={item.slug} {...item} />
        ))}
      </ul>
    </div>
  );
};

export default React.memo(SectionGroup);
